import React from "react";
import { ReviewTraceability } from "../../ReviewTraceability/ReviewTraceability";
import { useReviewTabContext } from "./ReviewTabContext";

export const ReviewTraceabilityTab: React.FC = () => {
  const { data } = useReviewTabContext();
  return <ReviewTraceability releaseId={data.releaseId} />;
};
